"use strict";

require("core-js/modules/es6.object.define-property");

exports.__esModule = true;
exports["default"] = NavBody;

var _react = _interopRequireWildcard(require("react"));

var _coreSc = require("@smooth-ui/core-sc");

var _NavContext = _interopRequireDefault(require("./NavContext"));

var _DarkShield = _interopRequireDefault(require("./DarkShield"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var Container = _coreSc.styled.div.withConfig({
  displayName: "NavBody__Container",
  componentId: "sc-1wm5gl4-0"
})(["flex:1;", ";", ";"], (0, _coreSc.down)('md', (0, _coreSc.css)(["position:fixed;top:0;left:0;right:0;bottom:0;height:100vh;display:flex;flex-direction:column;background-color:white;padding-top:100px;display:none;", ""], function (p) {
  return p.toggled && (0, _coreSc.css)(["display:block;z-index:5;"]);
})), (0, _coreSc.up)('md', (0, _coreSc.css)(["position:initial;opacity:1;height:55px;"])));

function NavBody(_ref) {
  var children = _ref.children;

  var _ref2 = (0, _react.useContext)(_NavContext["default"]),
      toggled = _ref2.toggled;

  return _react["default"].createElement(Container, {
    toggled: toggled
  }, _react["default"].createElement(_coreSc.Box, {
    flex: "0 0 auto",
    height: {
      xs: 'auto',
      md: 55
    },
    display: "flex",
    mt: {
      xs: 10,
      md: 0
    },
    alignItems: {
      xs: 'flex-start',
      md: 'center'
    },
    justifyContent: {
      xs: 'center',
      md: 'flex-end'
    }
  }, children), _react["default"].createElement(_coreSc.Box, {
    display: {
      xs: 'block',
      md: 'none'
    },
    flex: "1",
    pb: 200,
    pt: 40,
    textAlign: "center"
  }, _react["default"].createElement(_DarkShield["default"], {
    width: null,
    height: null,
    style: {
      width: '130px',
      height: 'auto'
    }
  })));
}